import React from 'react';
import { Neo, NeoGrid, Views } from '@singularsystems/neo-react';
import LadderProjectionVM from './LadderProjectionVM';
import { observer } from 'mobx-react';
import LadderProjection from '../../../Models/Catalogue/Pipeline/LadderProjection';
import { Catalogue } from '@singularsystems/neo-react-services';
import LadderAgeCatalogueEntry from './LadderAgeCatalogueEntry';
import { Misc } from '@singularsystems/neo-core';
import * as CatalogueRoles from "../../../Models/Security/CatalogueRoles"
import InvestorDividendReport from '../../../../Reporting/Reports/Dividends/InvestorDividendReport';
import InvestorDividendCriteria from '../../../../Reporting/Reports/Dividends/InvestorDividendCriteria';
import IssuerDividendReport from '../../../../Reporting/Reports/Dividends/IssuerDividendReport';
import IssuerDividendCriteria from '../../../../Reporting/Reports/Dividends/IssuerDividendCriteria';

class LadderProjectionParams {
    // TODO: Add parameters here in the form: public paramName = { isQuery?: boolean, required?: boolean };
}

@observer
export default class LadderProjectionView extends Views.ViewBase<LadderProjectionVM, LadderProjectionParams> {
    public static params = new LadderProjectionParams();

    constructor(props: unknown) {
        super("Ladder Projection", LadderProjectionVM, props);
    }

    protected viewParamsUpdated() {

    }

    public render() {
        const viewModel = this.viewModel;

        return (
            <Neo.Card title="Edit Ladder Projections">
                <div>
                    <div className="d-flex justify-content-between mb-4">
                        <Neo.Button icon="arrow-left" variant="light" onClick={() => history.back()}>Back</Neo.Button>
                        <div>
                            <Neo.Button onClick={() => this.viewModel.beginDividendsImport(false)} icon="upload" className="mr-2" >
                                Import Div. Payable
                            </Neo.Button>
                            <Neo.Button onClick={() => this.viewModel.beginDividendsImport(true)} icon="download" className="mr-2" >
                                Import Div. Receivable
                            </Neo.Button>
                            <Neo.Button
                                onClick={() => this.viewModel.saveLadderProjections()}
                                icon="save"
                                tooltip="Saves the current page of ladder projections."
                                pulse={this.viewModel.pageManager.data.readyToSave}
                                disabled={!this.viewModel.pageManager.data.isDirty}>
                                Save
                            </Neo.Button>
                        </div>
                    </div>
                    <Neo.Card title="Filter">
                        <div className="row">
                            <Neo.FormGroupInline bind={this.viewModel.criteria.meta.startDate} editorTooltip='If no date is selected, all results will be displayed.' className="col-lg-3" />
                            <Neo.FormGroupInline bind={this.viewModel.criteria.meta.endDate} editorTooltip='If no date is selected, all results will be displayed.' className="col-lg-3" />
                        </div>
                    </Neo.Card>
                    <Neo.Form model={this.viewModel.pageManager.data} showSummaryModal allReadOnly={!this.viewModel.authorisationService.hasRole(CatalogueRoles.LadderProjections.Edit)}>
                        <Neo.Card title={"Ladder Projections"}>
                            <Neo.Pager pageManager={this.viewModel.pageManager} pageControls="bottom" >
                                <NeoGrid.Grid<LadderProjection> showAddButton>
                                    {(ladderProjection, meta) => (
                                        <NeoGrid.Row>
                                            <NeoGrid.Column bind={meta.description} />
                                            <NeoGrid.Column bind={meta.effectiveDate} />
                                            <NeoGrid.Column bind={meta.amount} numProps={{ currencySymbol: "R", format: Misc.NumberFormat.CurrencyNoDecimals }} />
                                            <Catalogue.Column bind={meta.ladderAgeId} catalogueType={LadderAgeCatalogueEntry} />
                                            <NeoGrid.Column bind={meta.isBankOnly} label="Bank Only?" />
                                            <NeoGrid.Column bind={meta.isAsset} label="Asset?" />
                                            <NeoGrid.Column bind={meta.isDividend} label="Dividend?" />
                                            <NeoGrid.Column bind={meta.isActive} label="Active?" />
                                            <NeoGrid.ButtonColumn showDelete />
                                        </NeoGrid.Row>
                                    )}
                                </NeoGrid.Grid>
                            </Neo.Pager>
                        </Neo.Card>
                    </Neo.Form>
                </div>

                <Neo.Modal
                    title="Import Dividends Payable"
                    size="lg"
                    bindModel={viewModel.meta.investorDividendCriteria}
                    acceptButton={{
                        text: "Import Dividends Payable",
                        icon: "file-import",
                        onClick: () => {
                            viewModel.importDividends(viewModel.investorDividendCriteria!, false);
                        }
                    }}>
                    {(criteria: InvestorDividendCriteria) => (InvestorDividendReport.renderReportCriteria(criteria, viewModel.dataCache.entities, false))}
                </Neo.Modal>
                <Neo.Modal
                    title="Import Dividends Receivable"
                    size="lg"
                    bindModel={viewModel.meta.issuerDividendCriteria}
                    acceptButton={{
                        text: "Import Dividends Receivable",
                        icon: "file-import",
                        onClick: () => {
                            viewModel.importDividends(viewModel.issuerDividendCriteria!, true);
                        }
                    }}>
                    {(criteria: IssuerDividendCriteria) => (IssuerDividendReport.renderReportCriteria(criteria, viewModel.dataCache.entities))}
                </Neo.Modal>
            </Neo.Card>
        );
    }
}